import { Component, inject, input } from "@angular/core";
import { Router } from "@angular/router";

import { PermissionActionDescriptorType } from "../../../../../adaa-types";
import { AdaaHelper } from "../../../../core/utils";
import { PermissionAction } from "../../../constants/enums";
import { HasPermissionDirective } from "../../../directives";
import { PermissionActionModelType } from "../../../models";
import { ConsoleService, LanguageService, SystemLayoutService } from "../../../services";
import { ConsoleIconComponent } from "../console-icon/console-icon";

@Component({
  selector: "adaa-submenu",
  imports: [ConsoleIconComponent, HasPermissionDirective],
  template: `
    <div
      class="console-container d-flex justify-content-start flex-wrap align-content-center pe-3"
      [dir]="languageService.direction()"
    >
      @for (item of consoleService.consoleItems(); track item) {
        <adaa-console-icon [item]="item" *adaaHasPermission="getPermission(item.permissions)" />
      }
    </div>
  `,
})
export class SubmenuComponent {
  readonly languageService = inject(LanguageService);
  readonly consoleService = inject(ConsoleService);
  private _systemLayoutService = inject(SystemLayoutService);
  private _router = inject(Router);

  private readonly _untilDestroyed = AdaaHelper.untilDestroyed();

  onCycleChange = input<(router: Router, consoleService: ConsoleService) => void>();
  onEntityChange = input<(router: Router, consoleService: ConsoleService) => void>();

  public ngOnInit(): void {
    this.consoleService.init();

    this._systemLayoutService.hasCycleChanged$.pipe(this._untilDestroyed()).subscribe(() => {
      this.onCycleChange()?.(this._router, this.consoleService);
    });

    this._systemLayoutService.hasActiveEntityChanged$.pipe(this._untilDestroyed()).subscribe(() => {
      this.onEntityChange()?.(this._router, this.consoleService);
    });
  }

  public getPermission(permissionId: string | undefined): PermissionActionDescriptorType | undefined {
    if (permissionId) {
      const permissions = permissionId.split(",");
      const permissionsArray: PermissionActionModelType[] = [];

      permissions.forEach((e) => {
        permissionsArray.push(
          {
            permissionAction: PermissionAction.view,
            objectTypeId: +e,
          },
          {
            permissionAction: PermissionAction.manage,
            objectTypeId: +e,
          },
          {
            permissionAction: PermissionAction.execute,
            objectTypeId: +e,
          }
        );
      });

      return {
        actor: {
          modifier: "or",
          permissions: permissionsArray,
        },
      };
    } else return undefined;
  }
}
